import { CardPaymentDetailDto } from "./card-payment-detail-dto";

export class CardPayment {

    refNo: string;
    amount: number = 0;
    fromLocationCode: number;
    bankAccountCode: number;
    cardPaymentDetails: CardPaymentDetailDto[] = [];
}
